export const whatWorkData = {
  title: 'Could you please specify what type of job was carried out',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/5e64c8f9579d-tooliconquestion.jpg',
  },
  placeholderText: '',
}
